export const WAVE_EVENT_ROUTE = '/wave-event';
export const VIDEO_TEMPLATE_ROUTE = 'video-template-page';
export const CUSTOMIZE_WEBINAR_ROUTE = 'webinar';
